module.exports = __webpack_public_path__ + "static/media/sk.a49d2ab5.svg";